export const WHO_CAN_HIRE_SECTION = "WHO_CAN_HIRE_SECTION";
export const WHO_CAN_HIRE_SECTION_DEFAULT_POSITION = 1000;
